/**
 * Default vuex state
 *
 * @returns {object} Vuex state.
 */
export default () => ({
    user: null,
    profileControls: null,
    registeringUser: false,
    licenses: null,
    products: null,
    userCard: {},
    currentSubscription: null,
    userSubscription: null,
    paymentMethods: null,
    upcomingInvoice: null,
    presumedInvoice: null,
    invoices: null,
    loginRedirectUrl: '/',
    UIState: {
        isOnboardingModalVisible: false,
        isUpdateModalVisible: false,
        isDeactivateSiteModalVisible: false,
        isUpgradeModalVisible: false,
        isUpgradeProModalVisible: false,
        isResumeSubscriptionModalVisible: false,
        isCancelModalVisible: false,
        isFinishDowngradeView: false,
        isFinishCancelationView: false,
        isSuspended: false,
    },
    homeWidgets: [
        {
            component: 'GetStartedWidget',
            column: 1,
            order: 1,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'BetaAccessWidget',
            column: 1,
            order: 5,
            visible: true,
            subscriptionType: 'pro',
        },
        {
            component: 'ActiveSitesWidget',
            column: 1,
            order: 4,
            visible: true,
            subscriptionType: 'pro',
        },
        {
            component: 'ToolsWidget',
            column: 1,
            order: 3,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'KnowledgeBaseWidget',
            column: 2,
            order: 5,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'ProfileWidget',
            column: 2,
            order: 2,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'WebinarWidget',
            column: 2,
            order: 3,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'PattWebinarWidget',
            column: 2,
            order: 4,
            visible: true,
            subscriptionType: 'pro',
        },
        {
            component: 'HelpWidget',
            column: 2,
            order: 6,
            visible: true,
            subscriptionType: 'all',
        },
    ],
});
